module.exports = __webpack_public_path__ + "img/Linda Adams, 1968.5d6fa10c.jpg";